document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const compactNavigation = window.matchMedia('(max-width: 1100px)');
  const releaseDesktopScrollLock = () => {
    if (!compactNavigation.matches) document.body.classList.remove('menu-open', 'search-open');
  };

  releaseDesktopScrollLock();
  compactNavigation.addEventListener('change', releaseDesktopScrollLock);

  document.querySelectorAll('.shopify-policy__body h1').forEach((heading) => {
    const replacement = document.createElement('h2');
    Array.from(heading.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    while (heading.firstChild) replacement.append(heading.firstChild);
    heading.replaceWith(replacement);
  });

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details>summary, [tabindex]:not([tabindex="-1"])';
  const getFocusable = (root) => Array.from(root?.querySelectorAll(focusableSelector) || [])
    .filter((item) => !item.hidden && item.getAttribute('aria-hidden') !== 'true' && item.offsetParent !== null);
  const trapFocus = (event, root) => {
    if (event.key !== 'Tab' || !root) return;
    const focusable = getFocusable(root);
    if (!focusable.length) {
      event.preventDefault();
      root.focus?.();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  };

  const cartCopySource = document.querySelector('[data-cart-copy]');
  const cartCopy = (key, fallback = '') => cartCopySource?.dataset[key] || fallback;
  const publicCartError = (message, fallbackKey, fallback) => {
    const rawMessage = String(message || '');
    if (/inventory|stock|not available|available quantity|maximum|only\s+\d+|quantity remaining/i.test(rawMessage)) {
      return cartCopy('cartQuantityUnavailable', 'The requested quantity is not available. Please reduce the quantity and try again.');
    }
    return rawMessage || cartCopy(fallbackKey, fallback);
  };
  const secureImageUrl = (url) => {
    const source = String(url || '');
    const storefrontFile = source.match(/^(?:https?:)?\/\/[^/]+(\/cdn\/shop\/files\/.+)$/i);
    if (storefrontFile) return storefrontFile[1];
    const shopifyFile = source.match(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/.+\/files\/(.+)$/i);
    if (shopifyFile) return `/cdn/shop/files/${shopifyFile[1]}`;
    return source.replace(/^\/\//, 'https://');
  };

  const storefrontStatus = document.querySelector('[data-storefront-status]');
  const storefrontStatusMessage = storefrontStatus?.querySelector('[data-storefront-status-message]');
  let storefrontStatusTimer;
  const hideStorefrontStatus = () => {
    if (!storefrontStatus) return;
    storefrontStatus.hidden = true;
    storefrontStatus.classList.remove('is-visible');
  };
  const showStorefrontStatus = (message, type = 'error') => {
    if (!storefrontStatus || !storefrontStatusMessage) return;
    clearTimeout(storefrontStatusTimer);
    storefrontStatus.dataset.type = type;
    storefrontStatus.setAttribute('role', type === 'error' ? 'alert' : 'status');
    storefrontStatusMessage.textContent = String(message || 'Something went wrong. Please try again.');
    storefrontStatus.hidden = false;
    requestAnimationFrame(() => storefrontStatus.classList.add('is-visible'));
    storefrontStatusTimer = window.setTimeout(hideStorefrontStatus, 7000);
  };
  storefrontStatus?.querySelector('[data-storefront-status-close]')?.addEventListener('click', hideStorefrontStatus);

  const enhanceProductDescriptions = (scope = document) => {
    scope.querySelectorAll('[data-product-description]').forEach((description) => {
      // Preserve the existing Strider product-page treatment exactly.
      if (description.dataset.productVendor === 'strider') return;

      // Product descriptions come from many suppliers and often include their
      // own fonts, colours and spacing. Remove presentation-only attributes so
      // every product follows the Merla Baby theme without changing its facts.
      description.querySelectorAll('[style]:not(.product-description-content__media-grid)').forEach((element) => element.removeAttribute('style'));
      description.querySelectorAll('[align], [color], [face], [bgcolor]').forEach((element) => {
        ['align', 'color', 'face', 'bgcolor'].forEach((attribute) => element.removeAttribute(attribute));
      });
      description.querySelectorAll('font').forEach((element) => element.replaceWith(...element.childNodes));

      let content = Array.from(description.children).find((element) => element.classList.contains('merla-product-description'));
      if (!content) {
        const movableNodes = Array.from(description.childNodes);
        if (movableNodes.some((node) => node.nodeType === Node.ELEMENT_NODE || node.textContent.replace(/\u00a0/g, '').trim().length > 0)) {
          content = document.createElement('div');
          content.className = 'merla-product-description';
          description.insertBefore(content, movableNodes[0] || null);
          movableNodes.forEach((node) => content.appendChild(node));
        }
      }

      if (!content) return;

      Array.from(description.children).forEach((element) => {
        if (element !== content && !element.classList.contains('product-description-content__media-grid')) {
          content.appendChild(element);
        }
      });

      content.querySelectorAll('h1, h2, h4, h5, h6').forEach((heading) => {
        const replacement = document.createElement('h3');
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });

      const firstParagraph = content.querySelector('p');
      if (firstParagraph) firstParagraph.classList.add('merla-product-description__lead');

      const firstList = content.querySelector('ul, ol');
      if (firstList && !content.querySelector('h3')) {
        const heading = document.createElement('h3');
        heading.textContent = 'Details';
        firstList.before(heading);
      }

      if (description.dataset.productType === 'diaper') {
        Array.from(content.children).forEach((heading) => {
          const list = heading.nextElementSibling;
          if (!heading.matches('h3') || !list?.matches('ul, ol')) return;
          if (!/^(available sizes|choose their size|pack options)$/i.test(heading.textContent.trim())) return;
          heading.remove();
          list.remove();
        });
      }
      content.querySelectorAll('ul, ol').forEach((list) => list.classList.add('merla-product-description__list'));
      content.querySelectorAll('p').forEach((paragraph) => {
        if (/^(note|please note|good to know|care note)\s*:/i.test(paragraph.textContent.trim())) {
          paragraph.classList.add('merla-product-description__note');
        }
      });

      const isRecognizedVideoEmbed = (media) => {
        if (media.tagName !== 'IFRAME') return false;
        try {
          return /(^|\.)(youtube(?:-nocookie)?\.com|youtu\.be|vimeo\.com|wistia\.com|loom\.com)$/i.test(new URL(media.src, window.location.href).hostname);
        } catch (error) {
          return false;
        }
      };
      const getContentMedia = (block) => {
        const candidates = [
          ...(block.matches?.('img, video, iframe') ? [block] : []),
          ...block.querySelectorAll('img, video, iframe'),
        ];
        return candidates.filter((media) => media.tagName !== 'IFRAME' || isRecognizedVideoEmbed(media));
      };
      const isMediaOnly = (block, media) => {
        if (!media.length) return false;
        const copy = block.cloneNode(true);
        copy.querySelectorAll('picture, img, video, iframe, source, track, br').forEach((node) => node.remove());
        return !copy.textContent.replace(/\u00a0/g, '').trim();
      };
      const prepareMediaGrid = (grid, media) => {
        grid.classList.add('product-description-content__media-grid');
        grid.dataset.mediaCount = String(media.length);
        media.forEach((item) => {
          item.classList.add('product-description-content__media');
          if (item.tagName === 'VIDEO') item.controls = true;
          if (item.tagName === 'IFRAME' && !item.title) item.title = 'Product video';
        });
        grid.querySelectorAll('strong, b, em, i, span').forEach((wrapper) => {
          if (getContentMedia(wrapper).length && !wrapper.textContent.replace(/\u00a0/g, '').trim()) {
            wrapper.classList.add('product-description-content__media-wrapper');
          }
        });
      };
      const groupMediaRun = (run) => {
        if (!run.length) return;
        const media = run.flatMap((block) => getContentMedia(block));
        if (run.length === 1 && media.length > 1) {
          prepareMediaGrid(run[0], media);
          return;
        }
        const grid = document.createElement('div');
        run[0].before(grid);
        run.forEach((block) => grid.append(block));
        prepareMediaGrid(grid, media);
      };

      let mediaRun = [];
      Array.from(content.childNodes).forEach((node) => {
        const media = node.nodeType === Node.ELEMENT_NODE ? getContentMedia(node) : [];
        if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('product-description-content__media-grid') && isMediaOnly(node, media)) {
          mediaRun.push(node);
          return;
        }
        groupMediaRun(mediaRun);
        mediaRun = [];
      });
      groupMediaRun(mediaRun);
    });
  };

  enhanceProductDescriptions();
  document.addEventListener('shopify:section:load', (event) => enhanceProductDescriptions(event.target));

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const closeMobileGroups = (root = menu) => {
      root.querySelectorAll('.mobile-nav__group[open], .mobile-nav__subgroup[open]').forEach((group) => group.removeAttribute('open'));
    };

    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('menu-open', compactNavigation.matches && menu.open);
      if (compactNavigation.matches && menu.open) {
        window.setTimeout(() => menu.querySelector('[data-mobile-menu-close]')?.focus(), 30);
      } else if (!menu.open && menu.contains(document.activeElement)) {
        menu.querySelector(':scope > summary')?.focus();
      }
      if (!menu.open) closeMobileGroups();
    });

    const mobileMenuSummary = menu.querySelector(':scope > summary');
    mobileMenuSummary?.addEventListener('keydown', (event) => {
      if (!compactNavigation.matches || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      menu.open = !menu.open;
    });

    menu.addEventListener('keydown', (event) => {
      if (compactNavigation.matches && menu.open) trapFocus(event, menu.querySelector('.mobile-nav__panel'));
    });

    menu.querySelectorAll('.mobile-nav__group').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) {
          group.querySelectorAll('.mobile-nav__subgroup[open]').forEach((subgroup) => subgroup.removeAttribute('open'));
          return;
        }
        menu.querySelectorAll('.mobile-nav__group[open]').forEach((other) => {
          if (other !== group) other.removeAttribute('open');
        });
      });
    });

    menu.querySelectorAll('.mobile-nav__subgroup').forEach((subgroup) => {
      subgroup.addEventListener('toggle', () => {
        if (!subgroup.open) return;
        const container = subgroup.closest('.mobile-nav__children');
        container?.querySelectorAll('.mobile-nav__subgroup[open]').forEach((other) => {
          if (other !== subgroup) other.removeAttribute('open');
        });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const formId = form.getAttribute('id');
    const select = document.querySelector(`[data-variant-select="${formId}"]`);
    const optionInputs = Array.from(document.querySelectorAll(`[data-product-option="${formId}"]`));
    const optionGroups = Array.from(document.querySelectorAll(`[data-product-option-group="${formId}"]`));
    const variantInput = form.querySelector('[data-variant-input]');
    const button = form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]');

    // The select remains the JavaScript variant source, while the visible radio
    // groups provide the single accessible customer-facing control.
    select?.setAttribute('aria-hidden', 'true');
    select?.setAttribute('tabindex', '-1');
    const mobileButton = document.querySelector(`[data-mobile-product-submit="${formId}"]`);
    const mobilePrice = document.querySelector('[data-mobile-product-price]');
    if (!select || !variantInput || !button) return;

    const variantOptions = (selectOption) => {
      try { return JSON.parse(selectOption.dataset.options || '[]'); } catch (_error) { return []; }
    };
    const variants = Array.from(select.options).map((selectOption) => ({
      selectOption,
      options: variantOptions(selectOption),
      available: selectOption.dataset.available === 'true'
    }));
    const commerceDataElement = form.querySelector('[data-variant-commerce-data]');
    let commerceData = {};
    try { commerceData = JSON.parse(commerceDataElement?.textContent || '{}'); } catch (_error) { commerceData = {}; }
    const productDetails = form.closest('.product-details');
    const selectedOptionValues = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    const updateOptionStates = () => {
      const selected = selectedOptionValues();
      optionGroups.forEach((group) => {
        const current = group.querySelector('input:checked');
        const selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = current?.value || '';
      });
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const previousSelections = selected.slice(0, position);
        const matchesCandidate = (variant) => variant.options[position] === input.value && previousSelections.every((value, index) => !value || variant.options[index] === value);
        const anyMatch = variants.some(matchesCandidate);
        const availableMatch = variants.some((variant) => variant.available && matchesCandidate(variant));
        const label = input.closest('.product-option');
        input.disabled = !anyMatch;
        label?.classList.toggle('is-unavailable', !anyMatch);
        label?.classList.toggle('is-sold-out', anyMatch && !availableMatch);
        label?.setAttribute('aria-disabled', String(!anyMatch));
        const status = label?.querySelector('[data-option-status]');
        if (status) status.textContent = !anyMatch
          ? productRoot?.dataset.productCopyUnavailable || 'Unavailable'
          : availableMatch ? '' : productRoot?.dataset.productCopySoldOut || 'Sold out';
      });
    };

    const selectVariant = (variantId) => {
      const option = Array.from(select.options).find((item) => item.value === String(variantId));
      if (!option) return;

      const available = option.dataset.available === 'true';
      const selectedVariantOptions = variantOptions(option);
      select.value = option.value;
      variantInput.value = option.value;
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      if (mobileButton) {
        mobileButton.disabled = !available;
        mobileButton.textContent = available ? mobileButton.dataset.addLabel : mobileButton.dataset.soldLabel;
      }
      if (mobilePrice && option.dataset.price) mobilePrice.textContent = option.dataset.price;
      const price = document.querySelector(`#Price-${formId.replace('ProductForm-', '')}`);
      const currentPrice = price?.querySelector('.price-current');
      const comparePrice = price?.querySelector('.price-compare');
      if (currentPrice && option.dataset.price) currentPrice.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      const variantCommerce = commerceData[option.value] || {};
      const unitPrice = price?.querySelector('[data-unit-price]');
      const unitPriceValue = unitPrice?.querySelector('[data-unit-price-value]');
      const unitPriceReference = unitPrice?.querySelector('[data-unit-price-reference]');
      if (unitPrice) unitPrice.hidden = !variantCommerce.unitPrice;
      if (unitPriceValue) unitPriceValue.textContent = variantCommerce.unitPrice || '';
      if (unitPriceReference) unitPriceReference.textContent = variantCommerce.unitReference || '';

      const quantityInput = productDetails?.querySelector(`input[name="quantity"][form="${formId}"]`);
      const quantityRule = variantCommerce.quantity || { min: 1, max: null, increment: 1 };
      const quantityMin = Number(quantityRule.min) || 1;
      const quantityIncrement = Number(quantityRule.increment) || 1;
      const quantityMax = quantityRule.max == null ? null : Number(quantityRule.max);
      if (quantityInput) {
        quantityInput.min = String(quantityMin);
        quantityInput.step = String(quantityIncrement);
        if (quantityMax == null) quantityInput.removeAttribute('max');
        else quantityInput.max = String(quantityMax);
        const currentQuantity = Number(quantityInput.value);
        const fitsIncrement = Number.isFinite(currentQuantity) && Math.abs((currentQuantity - quantityMin) % quantityIncrement) < 0.000001;
        if (!Number.isFinite(currentQuantity) || currentQuantity < quantityMin || (quantityMax != null && currentQuantity > quantityMax) || !fitsIncrement) quantityInput.value = String(quantityMin);
      }
      const quantityRules = productDetails?.querySelector('[data-quantity-rules]');
      const productRoot = productDetails?.closest('.main-product');
      const productCopy = (key, fallback) => (productRoot?.dataset[key] || fallback).replace('__quantity__', String(quantityMin)).replace('__sku__', option.dataset.sku || '');
      if (quantityRules) {
        const minLabel = quantityRules.querySelector('[data-quantity-min]');
        const incrementLabel = quantityRules.querySelector('[data-quantity-increment]');
        const maxLabel = quantityRules.querySelector('[data-quantity-max]');
        if (minLabel) minLabel.textContent = productCopy('productCopyMinimum', `Minimum ${quantityMin}`);
        if (incrementLabel) {
          incrementLabel.textContent = (productRoot?.dataset.productCopyMultiples || `In multiples of ${quantityIncrement}`).replace('__quantity__', String(quantityIncrement));
          incrementLabel.hidden = quantityIncrement === 1;
        }
        if (maxLabel) {
          maxLabel.textContent = quantityMax == null ? '' : (productRoot?.dataset.productCopyMaximum || `Maximum ${quantityMax}`).replace('__quantity__', String(quantityMax));
          maxLabel.hidden = quantityMax == null;
        }
        quantityRules.hidden = quantityMin === 1 && quantityIncrement === 1 && quantityMax == null;
      }
      const priceBreaks = productDetails?.querySelector('[data-quantity-price-breaks]');
      const priceBreakList = priceBreaks?.querySelector('[data-quantity-price-break-list]');
      const breaks = Array.isArray(variantCommerce.priceBreaks) ? variantCommerce.priceBreaks : [];
      if (priceBreakList) {
        priceBreakList.replaceChildren();
        breaks.forEach((priceBreak) => {
          const item = document.createElement('li');
          const minimum = document.createElement('span');
          const perItem = document.createElement('span');
          minimum.textContent = `${priceBreak.minimum}+`;
          perItem.textContent = `${priceBreak.price} ${productRoot?.dataset.productCopyEach || 'each'}`;
          item.append(minimum, perItem);
          priceBreakList.append(item);
        });
      }
      if (priceBreaks) priceBreaks.hidden = breaks.length === 0;

      const sku = productDetails?.querySelector('[data-product-sku]');
      if (sku) {
        sku.textContent = option.dataset.sku ? (productRoot?.dataset.productCopySku || `SKU ${option.dataset.sku}`).replace('__sku__', option.dataset.sku) : '';
        sku.hidden = !option.dataset.sku;
      }
      const sellingPlans = form.querySelector('[data-selling-plans]');
      const sellingPlanData = form.querySelector('[data-selling-plan-data]');
      if (sellingPlans && sellingPlanData) {
        let allocations = [];
        try { allocations = JSON.parse(sellingPlanData.textContent)[option.value] || []; } catch (_error) { allocations = []; }
        const requiresSellingPlan = variantCommerce.requiresSellingPlan === true;
        const previousSelection = sellingPlans.querySelector('input[name="selling_plan"]:checked')?.value || '';
        const oneTimeLabel = sellingPlans.querySelector('[data-one-time-purchase]');
        const oneTimeInput = oneTimeLabel?.querySelector('input[name="selling_plan"]');
        if (oneTimeLabel) oneTimeLabel.hidden = requiresSellingPlan;
        if (oneTimeInput) {
          oneTimeInput.disabled = requiresSellingPlan;
          if (requiresSellingPlan) oneTimeInput.checked = false;
        }
        sellingPlans.querySelectorAll('.selling-plan:not([data-one-time-purchase])').forEach((label) => label.remove());
        const oneTimePrice = oneTimeLabel?.querySelector('small');
        if (oneTimePrice) oneTimePrice.textContent = option.dataset.price || '';
        allocations.forEach((allocation) => {
          const label = document.createElement('label');
          label.className = 'selling-plan';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = 'selling_plan';
          input.value = allocation.id;
          input.checked = String(allocation.id) === previousSelection;
          const copy = document.createElement('span');
          const name = document.createElement('strong');
          name.textContent = allocation.name;
          const allocationPrice = document.createElement('small');
          allocationPrice.textContent = allocation.price;
          copy.append(name, allocationPrice);
          label.append(input, copy);
          sellingPlans.append(label);
        });
        if (!sellingPlans.querySelector('input[name="selling_plan"]:checked')) {
          const fallbackPlan = requiresSellingPlan
            ? sellingPlans.querySelector('input[name="selling_plan"]:not([value=""])')
            : oneTimeInput;
          if (fallbackPlan) fallbackPlan.checked = true;
        }
        sellingPlans.hidden = allocations.length === 0;
        if (requiresSellingPlan && allocations.length === 0) {
          button.disabled = true;
          button.textContent = button.dataset.unavailableLabel || 'Unavailable';
          if (mobileButton) {
            mobileButton.disabled = true;
            mobileButton.textContent = mobileButton.dataset.unavailableLabel || 'Unavailable';
          }
        }
      }
      const availability = productDetails?.querySelector('[data-product-availability] span');
      if (availability && option.dataset.inventory) {
        availability.textContent = option.dataset.inventory;
        availability.classList.toggle('is-sold', !available);
        availability.classList.toggle('is-low', option.dataset.inventoryLow === 'true');
      }
      const restock = productDetails?.querySelector('[data-back-in-stock]');
      if (restock) {
        restock.hidden = available;
        restock.open = !available;
        const restockBody = restock.querySelector('[data-restock-body]');
        if (restockBody) restockBody.value = `Restock request for ${restockBody.dataset.productTitle} — ${option.dataset.title || option.textContent.trim()} (${option.dataset.url || restockBody.dataset.productUrl})`;
      }
      productDetails?.querySelectorAll('[data-pickup-variant]').forEach((pickup) => {
        pickup.hidden = pickup.dataset.pickupVariant !== option.value;
      });
      if (option.dataset.mediaId) {
        document.querySelector(`[data-gallery-thumb="${option.dataset.mediaId}"]`)?.click();
      }
      if (option.dataset.url) window.history.replaceState({}, '', option.dataset.url);
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        input.checked = input.value === selectedVariantOptions[position];
      });
      updateOptionStates();
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.dataset.productUrl) {
          window.location.assign(input.dataset.productUrl);
          return;
        }
        const selected = selectedOptionValues();
        const position = Number(input.dataset.optionPosition) - 1;
        const exactMatch = variants.find((variant) => variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index]));
        const prefix = selected.slice(0, position + 1);
        const matchesPrefix = (variant) => prefix.every((value, index) => !value || variant.options[index] === value);
        const match = exactMatch || variants.find((variant) => variant.available && matchesPrefix(variant)) || variants.find(matchesPrefix);
        if (match) selectVariant(match.selectOption.value);
        else {
          variantInput.value = '';
          button.disabled = true;
          button.textContent = button.dataset.unavailableLabel || 'Unavailable';
          updateOptionStates();
        }
      });
    });

    select.addEventListener('change', () => selectVariant(select.value));
    updateOptionStates();
  });

  document.querySelectorAll('[data-diaper-size-helper]').forEach((helper) => {
    const weightInput = helper.querySelector('[data-diaper-weight]');
    const ageInput = helper.querySelector('[data-diaper-age]');
    const submit = helper.querySelector('[data-diaper-size-submit]');
    const result = helper.querySelector('[data-diaper-size-result]');
    const optionGroup = helper.closest('[data-product-option-group]');
    const rows = Array.from(document.querySelectorAll('[data-diaper-row]'));
    if (!weightInput || !submit || !result || !optionGroup) return;

    const rangeFor = (value) => {
      const text = String(value || '').toLowerCase().replace(/,/g, '.');
      const numbers = (text.match(/\d+(?:\.\d+)?/g) || []).map(Number);
      if (!numbers.length) return null;
      if (text.includes('<')) return [0, numbers[0]];
      if (text.includes('+')) return [numbers[0], Number.POSITIVE_INFINITY];
      return [numbers[0], numbers[1] ?? numbers[0]];
    };

    submit.addEventListener('click', () => {
      const weight = Number(weightInput.value);
      const age = Number(ageInput?.value);
      if (!Number.isFinite(weight) || weight <= 0) {
        result.textContent = 'Enter your child’s current weight to find a starting size.';
        weightInput.focus();
        return;
      }
      if (!rows.length) {
        result.textContent = 'A size chart has not been added for this product yet. Please contact us before choosing a size.';
        return;
      }
      const candidates = rows.map((row) => ({ row, weightRange: rangeFor(row.dataset.weightRange), ageRange: rangeFor(row.dataset.ageRange) }));
      const byWeight = candidates.filter(({ weightRange }) => weightRange && weight >= weightRange[0] && weight <= weightRange[1]);
      const match = (Number.isFinite(age) && age >= 0
        ? byWeight.find(({ ageRange }) => ageRange && age >= ageRange[0] && age <= ageRange[1])
        : null) || byWeight[0];
      if (!match) {
        result.textContent = 'This measurement is outside this guide. Please check the full size chart.';
        return;
      }
      const recommended = String(match.row.dataset.size || '').trim();
      const option = Array.from(optionGroup.querySelectorAll('input[data-product-option]:not(:disabled)')).find((input) => {
        const value = input.value.trim().toLowerCase();
        const size = recommended.toLowerCase();
        return value === size || value.startsWith(size) || size.startsWith(value);
      });
      if (option) {
        option.checked = true;
        option.dispatchEvent(new Event('change', { bubbles: true }));
        result.textContent = `Based on ${weight} kg, ${recommended} is a good starting size.`;
      } else {
        result.textContent = `Based on ${weight} kg, try ${recommended}. Check the full size guide before adding to bag.`;
      }
    });
  });

  document.querySelectorAll('[data-quantity-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('input[name="quantity"]');
    if (!input) return;

    stepper.querySelectorAll('[data-quantity-change]').forEach((control) => {
      control.addEventListener('click', () => {
        const minimum = Number(input.min) || 1;
        const maximum = input.max === '' ? Number.POSITIVE_INFINITY : Number(input.max);
        const increment = Number(input.step) || 1;
        const current = Number(input.value) || minimum;
        const requested = current + (Number(control.dataset.quantityChange) * increment);
        input.value = String(Math.min(maximum, Math.max(minimum, requested)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const panels = Array.from(gallery.querySelectorAll('[data-gallery-panel]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const count = gallery.querySelector('[data-gallery-count]');
    let activeIndex = 0;
    let touchStartX = 0;

    const showMedia = (index) => {
      if (!panels.length) return;
      activeIndex = (index + panels.length) % panels.length;
      const targetId = panels[activeIndex].dataset.galleryPanel;

      panels.forEach((panel) => {
        const active = panel.dataset.galleryPanel === targetId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      thumbs.forEach((item) => {
        const active = item.dataset.galleryThumb === targetId;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (count) count.textContent = `${activeIndex + 1} / ${panels.length}`;
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showMedia(index));
    });

    previous?.addEventListener('click', () => showMedia(activeIndex - 1));
    next?.addEventListener('click', () => showMedia(activeIndex + 1));

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      showMedia(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
  });

  const closeMegaMenus = (exceptButton = null) => {
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      if (button === exceptButton) return;
      button.setAttribute('aria-expanded', 'false');
      button.closest('[data-menu-item]')?.classList.remove('is-open');
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  };

  const desktopMenu = window.matchMedia('(min-width: 1101px)');
  let megaMenuOpenTimer;
  let megaMenuCloseTimer;
  let lastMegaMenuButton;
  const openMegaMenu = (button) => {
    if (!button) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    window.clearTimeout(megaMenuOpenTimer);
    window.clearTimeout(megaMenuCloseTimer);
    /* Clicking a menu link moves focus into the already-open panel. Do not
       replay its entrance animation immediately before navigation. */
    if (button.getAttribute('aria-expanded') === 'true' && !panel.hidden) return;
    closeMegaMenus(button);
    lastMegaMenuButton = button;
    button.setAttribute('aria-expanded', 'true');
    button.closest('[data-menu-item]')?.classList.add('is-open');
    panel.hidden = false;
    if (desktopMenu.matches) document.body.classList.remove('menu-open');
    window.requestAnimationFrame(() => {
      panel.dispatchEvent(new CustomEvent('merla:mega-menu-open', { bubbles: true }));
    });
  };

  document.querySelectorAll('[data-menu-item]').forEach((item) => {
    const button = item.querySelector('[data-menu-toggle]');
    const panel = item.querySelector('[data-mega-menu]');
    if (!button) return;

    const scheduleMegaMenuClose = () => {
      window.clearTimeout(megaMenuOpenTimer);
      window.clearTimeout(megaMenuCloseTimer);
      megaMenuCloseTimer = window.setTimeout(() => {
        closeMegaMenus();
        if (!document.querySelector('[data-mobile-menu][open]')) document.body.classList.remove('menu-open');
      }, 280);
    };

    item.addEventListener('pointerenter', (event) => {
      if (!desktopMenu.matches || event.pointerType === 'touch') return;
      window.clearTimeout(megaMenuCloseTimer);
      window.clearTimeout(megaMenuOpenTimer);
      megaMenuOpenTimer = window.setTimeout(() => openMegaMenu(button), 90);
    });

    item.addEventListener('pointerleave', (event) => {
      if (!desktopMenu.matches || event.pointerType === 'touch') return;
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      scheduleMegaMenuClose();
    });

    panel?.addEventListener('pointerenter', () => {
      window.clearTimeout(megaMenuCloseTimer);
    });

    panel?.addEventListener('pointerleave', (event) => {
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      scheduleMegaMenuClose();
    });

    panel?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      if (event.detail > 0) link.blur();
      window.clearTimeout(megaMenuOpenTimer);
      window.clearTimeout(megaMenuCloseTimer);
      const destination = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);
      const isCurrentPage = destination.origin === current.origin
        && destination.pathname.replace(/\/+$/, '') === current.pathname.replace(/\/+$/, '')
        && destination.search === current.search;
      if (!isCurrentPage) return;
      event.preventDefault();
      closeMegaMenus();
    });

    item.addEventListener('focusin', (event) => {
      if (desktopMenu.matches && event.target !== button) openMegaMenu(button);
    });

    item.addEventListener('focusout', (event) => {
      if (!desktopMenu.matches || item.contains(event.relatedTarget)) return;
      window.clearTimeout(megaMenuCloseTimer);
      megaMenuCloseTimer = window.setTimeout(() => closeMegaMenus(), 220);
    });
  });

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    const toggleMegaMenu = () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      window.clearTimeout(megaMenuOpenTimer);
      window.clearTimeout(megaMenuCloseTimer);
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      if (willOpen) {
        openMegaMenu(button);
      } else {
        closeMegaMenus();
      }
      if (!compactNavigation.matches) {
        document.body.classList.remove('menu-open');
      } else {
        document.body.classList.toggle('menu-open', willOpen);
      }
    };

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleMegaMenu();
    });

    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      toggleMegaMenu();
    });
  });

  desktopMenu.addEventListener('change', () => {
    window.clearTimeout(megaMenuOpenTimer);
    window.clearTimeout(megaMenuCloseTimer);
    closeMegaMenus();
    if (!document.querySelector('[data-mobile-menu][open]')) document.body.classList.remove('menu-open');
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-menu-item]')) {
      closeMegaMenus();
      if (!document.querySelector('[data-mobile-menu][open]')) document.body.classList.remove('menu-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const hadOpenMegaMenu = Boolean(document.querySelector('[data-menu-toggle][aria-expanded="true"]'));
    const openMobileMenu = document.querySelector('[data-mobile-menu][open]');
    const mobileMenuOpener = openMobileMenu?.querySelector(':scope > summary');
    closeMegaMenus();
    document.querySelectorAll('[data-predictive-search][open], [data-mobile-menu][open]').forEach((item) => item.removeAttribute('open'));
    document.body.classList.remove('menu-open');
    setCartOpen(false);
    if (openMobileMenu) {
      mobileMenuOpener?.focus();
    } else if (hadOpenMegaMenu) {
      lastMegaMenuButton?.focus();
    }
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = button.closest('[data-mobile-menu]');
      const opener = menu?.querySelector(':scope > summary');
      menu?.removeAttribute('open');
      document.body.classList.remove('menu-open');
      opener?.focus();
    });
  });

  const formatMoney = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: document.body.dataset.currency || 'CAD'
      }).format(amount);
    } catch (_error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const makeResultLink = (item, type) => {
    const link = document.createElement('a');
    link.className = `predictive-result predictive-result--${type}`;
    link.href = item.url;

    const imageUrl = item.featured_image?.url || item.image?.url || (typeof item.image === 'string' ? item.image : '');
    if (type === 'product' && imageUrl) {
      const image = document.createElement('img');
      image.src = secureImageUrl(imageUrl);
      image.alt = item.featured_image?.alt || item.title || '';
      image.loading = 'lazy';
      link.appendChild(image);
    }

    const copy = document.createElement('span');
    const label = document.createElement('strong');
    label.textContent = item.title;
    copy.appendChild(label);
    if (type === 'product' && item.price != null) {
      const price = document.createElement('small');
      price.textContent = `${item.vendor ? `${item.vendor} · ` : ''}${formatMoney(item.price)}`;
      copy.appendChild(price);
    } else {
      const kind = document.createElement('small');
      kind.textContent = type;
      copy.appendChild(kind);
    }
    link.appendChild(copy);
    return link;
  };

  const prefixSearchQuery = (value) => {
    const query = value.trim();
    if (!query || /[*"'()]/.test(query) || !/[\p{L}\p{N}]$/u.test(query)) return query;
    return `${query}*`;
  };

  document.querySelectorAll('[data-prefix-search-form]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    form.addEventListener('submit', () => {
      if (input) input.value = prefixSearchQuery(input.value);
    });
    input?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.isComposing) return;
      event.preventDefault();
      form.requestSubmit();
    });
  });

  document.querySelectorAll('[data-predictive-search]').forEach((search) => {
    const opener = search.querySelector(':scope > summary');
    const panel = search.querySelector('.header-search__panel');
    const input = search.querySelector('[data-predictive-input]');
    const results = search.querySelector('[data-predictive-results]');
    const close = search.querySelector('[data-search-close]');
    let timer;
    let controller;
    const resultLinks = () => Array.from(results?.querySelectorAll('.predictive-result, .predictive-results__all') || []);
    const appendAllResults = (query, label = 'View all results') => {
      const allResults = document.createElement('a');
      allResults.className = 'predictive-results__all';
      allResults.href = `${search.querySelector('form')?.action || '/search'}?q=${encodeURIComponent(prefixSearchQuery(query))}&options%5Bprefix%5D=last`;
      const copy = document.createElement('span');
      copy.textContent = label;
      const arrow = document.createElement('b');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      allResults.append(copy, arrow);
      results.appendChild(allResults);
    };

    search.addEventListener('toggle', () => {
      document.body.classList.toggle('search-open', search.open);
      if (search.open) window.setTimeout(() => input?.focus(), 50);
      else if (search.contains(document.activeElement)) opener?.focus();
    });
    close?.addEventListener('click', () => search.removeAttribute('open'));
    search.addEventListener('keydown', (event) => {
      if (!search.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        search.removeAttribute('open');
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = resultLinks();
        if (links.length && (event.target === input || links.includes(event.target))) {
          event.preventDefault();
          const currentIndex = links.indexOf(event.target);
          const nextIndex = event.key === 'ArrowDown'
            ? (currentIndex + 1 + links.length) % links.length
            : (currentIndex < 0 ? links.length - 1 : (currentIndex - 1 + links.length) % links.length);
          links[nextIndex].focus();
          return;
        }
      }
      trapFocus(event, panel);
    });

    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '<p class="header-search__hint">Type at least two letters to search.</p>';
        results.removeAttribute('aria-busy');
        return;
      }

      results.setAttribute('aria-busy', 'true');
      timer = window.setTimeout(async () => {
        controller = new AbortController();
        const root = document.body.dataset.rootUrl || '/';
        const endpoint = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
        try {
          const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search request failed');
          const data = await response.json();
          const found = data.resources?.results || {};
          results.replaceChildren();
          const groups = [
            ['Products', found.products || [], 'product'],
            ['Collections', found.collections || [], 'collection'],
            ['Guides & pages', [...(found.pages || []), ...(found.articles || [])], 'page']
          ];
          groups.forEach(([title, items, type]) => {
            if (!items.length) return;
            const group = document.createElement('section');
            group.className = 'predictive-group';
            const heading = document.createElement('p');
            heading.className = 'eyebrow';
            heading.textContent = title;
            group.appendChild(heading);
            items.forEach((item) => group.appendChild(makeResultLink(item, type)));
            results.appendChild(group);
          });
          if (!results.children.length) {
            results.innerHTML = '<p class="header-search__hint">No matches yet. Try a product type, brand or age.</p>';
            appendAllResults(query, `Search for “${query}”`);
          } else {
            appendAllResults(query);
          }
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = '<p class="header-search__hint merla-state merla-state--compact merla-state--error" role="alert">Search is temporarily unavailable. Press Enter to view all results.</p>';
        } finally {
          results.removeAttribute('aria-busy');
        }
      }, 220);
    });
  });

  const quickAddDrawer = document.querySelector('[data-quick-add-drawer]');
  const quickAddPanel = quickAddDrawer?.querySelector('.quick-add-drawer__panel');
  const quickAddContent = quickAddDrawer?.querySelector('[data-quick-add-content]');
  const quickAddTitle = quickAddDrawer?.querySelector('[data-quick-add-title]');
  let quickAddOpener = null;
  let quickAddRequest = null;

  const setQuickAddOpen = (open, restoreFocus = true) => {
    if (!quickAddDrawer) return;
    quickAddDrawer.setAttribute('aria-hidden', String(!open));
    if (!open) quickAddContent?.removeAttribute('aria-busy');
    document.body.classList.toggle('quick-add-open', open);
    quickAddOpener?.setAttribute('aria-expanded', String(open));
    if (open) window.setTimeout(() => quickAddPanel?.focus(), 40);
    else if (restoreFocus && quickAddOpener?.isConnected) quickAddOpener.focus();
  };

  const renderQuickAddProduct = (product) => {
    if (!quickAddContent) return;
    const availableVariants = product.variants.filter((variant) => variant.available);
    const selectedVariant = availableVariants[0];
    if (!selectedVariant) {
      quickAddContent.replaceChildren();
      const empty = document.createElement('div');
      empty.className = 'quick-add-drawer__state merla-state merla-state--compact merla-state--empty';
      const heading = document.createElement('h3');
      heading.textContent = 'Currently unavailable';
      const copy = document.createElement('p');
      copy.textContent = 'This item has no available choices right now.';
      const link = document.createElement('a');
      link.className = 'text-link';
      link.href = product.url;
      link.textContent = 'View product details';
      empty.append(heading, copy, link);
      quickAddContent.appendChild(empty);
      return;
    }

    const layout = document.createElement('div');
    layout.className = 'quick-add-drawer__product';
    const imageWrap = document.createElement('a');
    imageWrap.className = 'quick-add-drawer__image';
    imageWrap.href = product.url;
    const image = document.createElement('img');
    image.src = secureImageUrl(product.featured_image || selectedVariant.featured_image?.src);
    image.alt = product.title;
    image.loading = 'eager';
    if (image.src) imageWrap.appendChild(image);

    const form = document.createElement('form');
    form.className = 'quick-add-drawer__form';
    form.method = 'post';
    form.action = `${document.body.dataset.rootUrl || '/'}cart/add`;
    form.dataset.productForm = '';
    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = selectedVariant.id;
    idInput.dataset.variantInput = '';

    const quickMoney = (value) => {
      const formatted = formatMoney(Number(value) / 100);
      return (document.body.dataset.currency || 'CAD') === 'CAD' ? formatted.replace(/^CA\$/, 'C$') : formatted;
    };
    const price = document.createElement('p');
    price.className = 'quick-add-drawer__price';
    price.textContent = quickMoney(selectedVariant.price);
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'quick-add-drawer__choices';
    const legend = document.createElement('legend');
    const optionNames = (product.options || []).map((option) => typeof option === 'string' ? option : option.name).filter(Boolean);
    legend.textContent = optionNames.join(' / ') || 'Choose an option';
    fieldset.appendChild(legend);

    product.variants.forEach((variant) => {
      const label = document.createElement('label');
      label.className = `quick-add-choice${variant.available ? '' : ' is-unavailable'}`;
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `quick-add-${product.id}`;
      input.value = variant.id;
      input.disabled = !variant.available;
      input.checked = variant.id === selectedVariant.id;
      input.dataset.variantPrice = variant.price;
      input.dataset.variantImage = secureImageUrl(variant.featured_image?.src);
      const copy = document.createElement('span');
      const name = document.createElement('strong');
      name.textContent = variant.public_title || variant.title;
      const meta = document.createElement('small');
      meta.textContent = variant.available ? quickMoney(variant.price) : 'Sold out';
      copy.append(name, meta);
      label.append(input, copy);
      fieldset.appendChild(label);
    });

    fieldset.addEventListener('change', (event) => {
      const input = event.target.closest('input[type="radio"]');
      if (!input) return;
      idInput.value = input.value;
      price.textContent = quickMoney(input.dataset.variantPrice);
      if (input.dataset.variantImage) image.src = secureImageUrl(input.dataset.variantImage);
    });

    const submit = document.createElement('button');
    submit.className = 'button button--solid button--full';
    submit.type = 'submit';
    submit.name = 'add';
    submit.dataset.addLabel = 'Add to bag';
    submit.dataset.soldLabel = 'Sold out';
    submit.textContent = 'Add to bag';
    const detailLink = document.createElement('a');
    detailLink.className = 'quick-add-drawer__details text-link';
    detailLink.href = product.url;
    detailLink.textContent = 'View full product details';
    form.append(idInput, price, fieldset, submit, detailLink);
    layout.append(imageWrap, form);
    quickAddContent.replaceChildren(layout);
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-quick-add-open]');
    if (!opener || !quickAddDrawer) return;
    event.preventDefault();
    quickAddRequest?.abort();
    const request = new AbortController();
    const requestTimeout = window.setTimeout(() => request.abort(), 10000);
    quickAddRequest = request;
    quickAddOpener?.setAttribute('aria-expanded', 'false');
    quickAddOpener = opener;
    if (quickAddTitle) quickAddTitle.textContent = opener.dataset.productTitle || 'Product options';
    if (quickAddContent) {
      quickAddContent.setAttribute('aria-busy', 'true');
      quickAddContent.innerHTML = '<p class="quick-add-drawer__loading merla-state merla-state--compact merla-state--loading">Loading available choices…</p>';
    }
    setQuickAddOpen(true);
    try {
      const productUrl = opener.dataset.productUrl.split('?')[0];
      const response = await fetch(`${productUrl}.js`, { signal: request.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Options could not be loaded.');
      renderQuickAddProduct(await response.json());
      quickAddContent?.removeAttribute('aria-busy');
      window.setTimeout(() => quickAddContent?.querySelector('input:not([disabled])')?.focus(), 20);
    } catch (error) {
      if (quickAddRequest !== request || !quickAddContent) return;
      quickAddContent.removeAttribute('aria-busy');
      const state = document.createElement('div');
      state.className = 'quick-add-drawer__state merla-state merla-state--compact merla-state--error';
      const heading = document.createElement('h3');
      heading.textContent = 'Options could not be loaded';
      const copy = document.createElement('p');
      copy.textContent = 'Open the product page to choose an available option.';
      const link = document.createElement('a');
      link.className = 'button button--solid';
      link.href = opener.dataset.productUrl;
      link.textContent = 'View product';
      state.append(heading, copy, link);
      quickAddContent.replaceChildren(state);
    } finally {
      window.clearTimeout(requestTimeout);
      if (quickAddRequest === request) quickAddRequest = null;
    }
  });

  quickAddDrawer?.querySelectorAll('[data-quick-add-close]').forEach((button) => button.addEventListener('click', () => setQuickAddOpen(false)));
  document.addEventListener('keydown', (event) => {
    if (!quickAddDrawer || quickAddDrawer.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setQuickAddOpen(false);
    } else {
      trapFocus(event, quickAddPanel);
    }
  });

  const recentlyViewedKey = 'merla-baby:recently-viewed-v1';
  const recentlyViewedSection = document.querySelector('[data-recently-viewed]');
  const recentlyViewedRail = recentlyViewedSection?.querySelector('[data-recently-viewed-rail]');
  const currentProductData = document.querySelector('[data-current-product-card]');
  const readRecentlyViewed = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem(recentlyViewedKey) || '[]');
      return Array.isArray(items) ? items.filter((item) => item?.handle && item?.url && item?.title).slice(0, 6) : [];
    } catch (_error) {
      return [];
    }
  };
  const writeRecentlyViewed = (items) => {
    try { window.localStorage.setItem(recentlyViewedKey, JSON.stringify(items.slice(0, 6))); } catch (_error) { /* Storage can be disabled. */ }
  };
  const makeRecentlyViewedCard = (item) => {
    const article = document.createElement('article');
    article.className = 'recently-viewed-card';
    const media = document.createElement('a');
    media.className = 'recently-viewed-card__media';
    media.href = item.url;
    media.setAttribute('aria-label', item.title);
    if (item.image) {
      const image = document.createElement('img');
      image.src = secureImageUrl(item.image);
      image.alt = item.title;
      image.loading = 'lazy';
      media.appendChild(image);
    }
    const copy = document.createElement('div');
    copy.className = 'recently-viewed-card__copy';
    if (item.vendor) {
      const vendor = document.createElement('small');
      vendor.textContent = item.vendor;
      copy.appendChild(vendor);
    }
    const heading = document.createElement('h3');
    const link = document.createElement('a');
    link.href = item.url;
    link.textContent = item.title;
    heading.appendChild(link);
    const price = document.createElement('span');
    price.textContent = item.price || '';
    copy.append(heading, price);
    article.append(media, copy);
    return article;
  };

  if (recentlyViewedSection && recentlyViewedRail) {
    let currentProduct = null;
    try { currentProduct = currentProductData ? JSON.parse(currentProductData.textContent) : null; } catch (_error) { /* Invalid theme data should not block the page. */ }
    const storedItems = readRecentlyViewed();
    const visibleItems = storedItems.filter((item) => item.handle !== currentProduct?.handle).slice(0, 5);
    if (visibleItems.length) {
      visibleItems.forEach((item) => recentlyViewedRail.appendChild(makeRecentlyViewedCard(item)));
      recentlyViewedSection.hidden = false;
    }
    if (currentProduct?.handle) {
      writeRecentlyViewed([{ ...currentProduct, viewedAt: Date.now() }, ...storedItems.filter((item) => item.handle !== currentProduct.handle)]);
    }
  }

  let cartOpener = null;
  const setCartOpen = (open) => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    if (open) {
      document.querySelector('[data-wishlist-drawer]')?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wishlist-open');
    }
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('cart-open', open);
    if (open) window.setTimeout(() => drawer.querySelector('.cart-drawer__panel')?.focus(), 50);
    else if (cartOpener?.isConnected) cartOpener.focus();
  };

  let wishlistOpener = null;
  const setWishlistOpen = (open) => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    if (open) {
      document.querySelector('[data-cart-drawer]')?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    }
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('wishlist-open', open);
    if (open) window.setTimeout(() => drawer.querySelector('.cart-drawer__panel')?.focus(), 50);
    else if (wishlistOpener?.isConnected) wishlistOpener.focus();
  };

  const replaceCartDrawer = (sectionHtml) => {
    if (!sectionHtml) return;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const replacement = parsed.querySelector('#shopify-section-cart-drawer');
    const current = document.querySelector('#shopify-section-cart-drawer');
    if (replacement && current) current.replaceWith(replacement);
  };

  const refreshCartPage = async () => {
    const current = document.querySelector('.cart-page');
    if (!current) return;
    try {
      const root = document.body.dataset.rootUrl || '/';
      const response = await fetch(`${root}cart`, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = parsed.querySelector('.cart-page');
      if (replacement) current.replaceWith(replacement);
    } catch {
      /* The cart mutation has already succeeded; keep its confirmation usable
         even when a non-critical page-fragment refresh is unavailable. */
    }
  };

  const updateCartCount = (itemCount) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = itemCount;
      count.hidden = itemCount < 1;
    });
  };

  document.addEventListener('click', (event) => {
    const wishlistOpenerTarget = event.target.closest('[data-wishlist-open]');
    if (wishlistOpenerTarget && document.querySelector('[data-wishlist-drawer]')) {
      event.preventDefault();
      wishlistOpener = wishlistOpenerTarget;
      setWishlistOpen(true);
      return;
    }
    if (event.target.closest('[data-wishlist-close]')) {
      setWishlistOpen(false);
      return;
    }
    const opener = event.target.closest('[data-cart-open]');
    if (opener && document.querySelector('[data-cart-drawer]')) {
      event.preventDefault();
      cartOpener = opener;
      setCartOpen(true);
    }
    if (event.target.closest('[data-cart-close]')) setCartOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    const drawer = document.querySelector('[data-cart-drawer][aria-hidden="false"], [data-wishlist-drawer][aria-hidden="false"]');
    if (!drawer) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (drawer.matches('[data-wishlist-drawer]')) setWishlistOpen(false);
      else setCartOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details>summary, [tabindex]:not([tabindex="-1"])')).filter((item) => !item.hidden && item.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !document.querySelector('[data-cart-drawer]')) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const mobileButton = form.id ? document.querySelector(`[data-mobile-product-submit="${form.id}"]`) : null;
    const liveRegion = document.getElementById('CartLiveRegion');
    const originalLabel = button?.textContent;
    const wasDisabled = button?.disabled;
    const mobileOriginalLabel = mobileButton?.textContent;
    const mobileWasDisabled = mobileButton?.disabled;
    if (button) {
      button.disabled = true;
      button.textContent = cartCopy('cartAdding', 'Adding…');
    }
    if (mobileButton) {
      mobileButton.disabled = true;
      mobileButton.textContent = cartCopy('cartAdding', 'Adding…');
    }

    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      const root = document.body.dataset.rootUrl || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok) throw new Error(publicCartError(data.description, 'cartAddError', 'This item could not be added.'));

      const sectionHtml = data.sections?.['cart-drawer'];
      replaceCartDrawer(sectionHtml);

      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);
      await refreshCartPage();
      if (liveRegion) liveRegion.textContent = cartCopy('cartAdded', 'Added to your bag.');
      if (form.closest('[data-quick-add-drawer]')) setQuickAddOpen(false, false);
      setCartOpen(true);
    } catch (error) {
      if (liveRegion) liveRegion.textContent = error.message;
      showStorefrontStatus(error.message);
    } finally {
      if (button) {
        button.disabled = Boolean(wasDisabled);
        button.textContent = originalLabel;
      }
      if (mobileButton) {
        mobileButton.disabled = Boolean(mobileWasDisabled);
        mobileButton.textContent = mobileOriginalLabel;
      }
    }
  });

  document.querySelectorAll('[data-bundle-add]').forEach((bundleButton) => bundleButton.addEventListener('click', async (event) => {
    if (!document.querySelector('[data-cart-drawer]')) return;
    const productForm = document.getElementById(bundleButton.dataset.productFormId);
    const selectedVariant = productForm?.querySelector('[name="id"]')?.value;
    const companionVariant = bundleButton.dataset.bundleVariantId;
    if (!selectedVariant || !companionVariant) return;

    event.preventDefault();
    const liveRegion = document.getElementById('CartLiveRegion');
    const originalLabel = bundleButton.textContent;
    bundleButton.disabled = true;
    bundleButton.textContent = cartCopy('cartAddingPair', 'Adding both…');

    try {
      const root = document.body.dataset.rootUrl || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            { id: Number(selectedVariant), quantity: 1 },
            { id: Number(companionVariant), quantity: 1 }
          ],
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(publicCartError(data.description, 'cartPairError', 'This pair could not be added.'));

      replaceCartDrawer(data.sections?.['cart-drawer']);
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);
      await refreshCartPage();
      if (liveRegion) liveRegion.textContent = cartCopy('cartAddedPair', 'Both items were added to your bag.');
      setCartOpen(true);
    } catch (error) {
      if (liveRegion) liveRegion.textContent = error.message;
      showStorefrontStatus(error.message);
    } finally {
      bundleButton.disabled = false;
      bundleButton.textContent = originalLabel;
    }
  }));

  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (!control || !document.querySelector('[data-cart-drawer]')) return;
    event.preventDefault();
    const liveRegion = document.getElementById('CartLiveRegion');
    const root = document.body.dataset.rootUrl || '/';
    const quantity = control.matches('[data-cart-remove]') ? 0 : Number(control.dataset.quantity);
    control.disabled = true;
    control.closest('.cart-drawer__item')?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: control.dataset.line,
          quantity: Math.max(0, quantity),
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(publicCartError(cart.description, 'cartUpdateError', 'Your bag could not be updated.'));
      replaceCartDrawer(cart.sections?.['cart-drawer']);
      updateCartCount(cart.item_count);
      await refreshCartPage();
      if (liveRegion) liveRegion.textContent = quantity === 0
        ? cartCopy('cartItemRemoved', 'Item removed from your bag.')
        : cartCopy('cartQuantityUpdated', 'Bag quantity updated.');
      setCartOpen(true);
    } catch (error) {
      control.disabled = false;
      control.closest('.cart-drawer__item')?.removeAttribute('aria-busy');
      if (liveRegion) liveRegion.textContent = error.message;
      showStorefrontStatus(error.message);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const code = new FormData(form).get('discount')?.toString().trim();
    if (!code) return;
    const button = form.querySelector('[type="submit"]');
    const root = document.body.dataset.rootUrl || '/';
    const note = document.querySelector('#CartDrawerNote, #CartNote')?.value || '';
    if (button) button.disabled = true;

    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });
      window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=/checkout`);
    } catch (error) {
      if (button) button.disabled = false;
      showStorefrontStatus('The discount code could not be applied. Please try again.');
    }
  });

  document.addEventListener('click', (event) => {
    const adjuster = event.target.closest('[data-cart-page-adjust]');
    if (!adjuster) return;
    const input = document.getElementById(adjuster.dataset.cartPageTarget);
    if (!input) return;
    const nextValue = Math.max(0, Number(input.value || 0) + Number(adjuster.dataset.cartPageAdjust));
    input.value = nextValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[data-tab-button]'));
    const panels = Array.from(tabs.querySelectorAll('[data-tab-panel]'));
    const activate = (id, focus = false) => {
      buttons.forEach((button) => {
        const active = button.dataset.tabButton === id;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.tabPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.tabButton));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        activate(buttons[nextIndex].dataset.tabButton, true);
      });
    });
  });

  const finderCopySource = document.querySelector('[data-merla-finder-form]');
  const finderCopy = (key, fallback = '') => finderCopySource?.dataset[key] || fallback;
  const finderTemplate = (key, value, fallback) => finderCopy(key, fallback).replace(/__amount__|__count__/g, String(value));
  const finderIntentLabel = (intent) => finderCopy(`finder${intent.charAt(0).toUpperCase()}${intent.slice(1)}`, finderIntents[intent]?.label || intent);

  const finderIntents = {
    diapering: {
      label: 'Diapering & care',
      search: 'diaper',
      words: ['diaper', 'nappy', 'wipe', 'change', 'sensitive skin', 'rash', '纸尿裤', '尿布'],
      reason: 'Chosen to support gentler, easier everyday changes.'
    },
    feeding: {
      label: 'Feeding',
      search: 'bottle',
      words: ['feed', 'bottle', 'solid', 'meal', 'cup', 'bib', 'tableware', 'snack', '辅食', '奶瓶'],
      reason: 'A practical match for calmer meals, first tastes and everyday feeding routines.'
    },
    sleep: {
      label: 'Sleep',
      search: 'sleep',
      words: ['sleep', 'bed', 'night', 'nap', 'soothe', 'comfort', '睡眠', '安抚'],
      reason: 'Selected to bring more comfort and ease to rest time.'
    },
    play: {
      label: 'Play & learning',
      search: 'toy',
      words: ['play', 'toy', 'puzzle', 'learn', 'creative', 'art', 'book', 'music', 'motor', 'sensory', '玩具', '拼图', '创造'],
      reason: 'Matched to growing curiosity, confidence and hands-on discovery.'
    },
    travel: {
      label: 'Travel & gear',
      search: 'travel',
      words: ['travel', 'stroller', 'car seat', 'outing', 'carrier', 'trip', 'on the go', '出行', '推车'],
      reason: 'A useful choice for easier outings and family days on the go.'
    },
    gift: {
      label: 'Finding a gift',
      search: 'toy',
      words: ['gift', 'birthday', 'present', 'celebrat', 'shower', '送礼', '生日'],
      reason: 'A thoughtful, giftable choice for the age and occasion you described.'
    }
  };

  const finderWordMatches = (text, word) => {
    if (/^[a-z]+$/.test(word) && word.length <= 4) return new RegExp(`\\b${word}\\b`, 'i').test(text);
    return text.includes(word);
  };

  const inferFinderIntent = (prompt, selectedNeed) => {
    if (selectedNeed && finderIntents[selectedNeed]) return selectedNeed;
    const normalized = prompt.toLowerCase();
    return Object.keys(finderIntents).find((key) => finderIntents[key].words.some((word) => finderWordMatches(normalized, word))) || 'play';
  };

  const finderBlockedInstructions = /\b(?:ignore|override|reveal|repeat|show)\b.{0,35}\b(?:instructions?|prompt|rules?|system|developer)\b|\b(?:jailbreak|act as|pretend to be)\b/i;
  const finderClearlyOutOfScope = /\b(?:weather|forecast|politics?|election|president|prime minister|stock price|crypto|bitcoin|sports? score|homework|essay|coding|javascript|python|translate|translation|recipe|horoscope|joke)\b/i;
  const finderShoppingSignals = [
    /\b(?:baby|babies|child|children|kid|kids|newborn|infant|toddler|preschool|parent|mom|mum|dad)\b/i,
    /\b(?:gift|present|birthday|shower|budget|under|below|recommend|suggest|find|looking for|shop)\b/i,
    /\b(?:diaper|nappy|wipe|bottle|cup|bib|feeding|sleep|soothe|toy|play|puzzle|book|art|creative|camera|stroller|carrier|travel)\b/i,
    /\b\d+\s*(?:months?|mos?|years?|yrs?|kg|lb|lbs)\b/i,
    /(?:宝宝|婴儿|孩子|纸尿裤|尿布|奶瓶|喂养|睡眠|玩具|拼图|绘画|礼物|预算|推荐|岁|个月)/
  ];

  const finderPromptIsInScope = (prompt, selectedNeed) => {
    if (finderBlockedInstructions.test(prompt)) return false;
    if (finderClearlyOutOfScope.test(prompt)) return false;
    if (finderShoppingSignals.some((pattern) => pattern.test(prompt))) return true;
    if (!prompt.trim() && selectedNeed && finderIntents[selectedNeed]) return true;
    return false;
  };

  const finderSearchTerm = (prompt, intent) => {
    const normalized = prompt.toLowerCase();
    const specificTerms = [
      [/\bpuzzles?\b/i, 'puzzle'], [/拼图/i, 'puzzle'], [/\bbooks?\b/i, 'book'],
      [/\bart\b/i, 'art'], [/\bcreative\b/i, 'art'], [/\bbottles?\b/i, 'bottle'], [/\bcups?\b/i, 'cup'],
      [/\bbibs?\b/i, 'bib'], [/\bdiapers?\b/i, 'diaper'], [/\bwipes?\b/i, 'wipes'], [/\bstrollers?\b/i, 'stroller']
    ];
    const specific = specificTerms.find(([pattern]) => pattern.test(normalized));
    return specific?.[1] || finderIntents[intent]?.search || 'baby';
  };

  const finderProductProfiles = [
    {
      pattern: /origami|craft|paint|drawing|marker|colour|color|designer|art supplies|finger paint/,
      noun: 'creative activity',
      benefit: 'invites creative expression and hands-on making'
    },
    {
      pattern: /camera|photo|print camera/,
      noun: 'creative camera',
      benefit: 'turns everyday discoveries into a creative activity'
    },
    {
      pattern: /puzzle|jigsaw|maze|tangram|construction|building|block|stacking/,
      noun: 'hands-on challenge',
      benefit: 'invites spatial thinking and step-by-step problem-solving'
    },
    {
      pattern: /book|alphabet|\babc\b|word|language|song|music|sound/,
      noun: 'interactive learning pick',
      benefit: 'supports listening, language and shared discovery'
    },
    {
      pattern: /strider|ride|sport|ball|balance|outdoor|movement/,
      noun: 'active-play pick',
      benefit: 'encourages movement, balance and active confidence'
    },
    {
      pattern: /sensory|plush|teeth|rattle|play mat|soother/,
      noun: 'sensory play pick',
      benefit: 'offers gentle sensory exploration through touch and play'
    },
    {
      pattern: /diaper|nappy|pull.?up|wipe/,
      noun: 'diapering essential',
      benefit: 'supports a more practical everyday changing routine'
    },
    {
      pattern: /bottle|cup|bib|tableware|spoon|feeding|snack/,
      noun: 'mealtime essential',
      benefit: 'fits everyday feeding and independent-mealtime routines'
    },
    {
      pattern: /stroller|carrier|travel|fan|on the go/,
      noun: 'on-the-go essential',
      benefit: 'is designed for easier family outings'
    },
    {
      pattern: /sleep|bed|night|blanket|comfort/,
      noun: 'rest-time essential',
      benefit: 'adds comfort to naps, bedtime and winding down'
    }
  ];

  const finderAgeSignals = {
    newborn: /newborn|0[-–]3 months/,
    baby: /3[-–]12 months|0[-–]6 months|6[-–]12 months|baby/,
    toddler: /1[-–]3 years|12[-–]24 months|24 months\+|toddler/,
    kids: /3\+ years|3[-–]5 years|5\+ years|preschool|kids?/
  };

  const finderProductDetails = [
    { pattern: /finger paint/, detail: 'Its finger-paint format encourages tactile, screen-free mark making' },
    { pattern: /watercolor|watercolour/, detail: 'Its watercolor format makes room for colour mixing and careful brush control' },
    { pattern: /marker/, detail: 'The marker format makes it easy to experiment with lines, colour and personal style' },
    { pattern: /paper pad|paint paper|drawing paper/, detail: 'The open-ended paper format gives their own ideas plenty of room' },
    { pattern: /origami/, detail: 'Following each fold combines creative expression with sequencing and hand control' },
    { pattern: /camera|photo/, detail: 'Taking their own pictures turns observation and storytelling into the activity' },
    { pattern: /puzzle|jigsaw|tangram/, detail: 'Completing the picture invites visual matching, persistence and spatial reasoning' },
    { pattern: /construction|building|block|stacking/, detail: 'Building and rebuilding encourages planning, balance and open-ended problem-solving' },
    { pattern: /book|alphabet|\babc\b|word|language/, detail: 'The book format supports shared reading, vocabulary and repeat discovery' },
    { pattern: /song|music|sound/, detail: 'Sound and repetition invite listening, participation and shared play' },
    { pattern: /strider|ride|balance/, detail: 'Its ride-on format encourages balance, coordination and active confidence' },
    { pattern: /sport|ball|movement/, detail: 'The active-play format encourages movement and whole-body coordination' },
    { pattern: /sensory|rattle|teeth|plush/, detail: 'Texture and hands-on play offer a gentle sensory starting point' }
  ];

  const finderThemeDetails = [
    { pattern: /animal|safari|dino/, detail: 'The familiar animal theme adds an easy invitation to imagine and talk' },
    { pattern: /city|wander|travel|expedition/, detail: 'The exploration theme can spark stories beyond the finished activity' },
    { pattern: /fairy|wonderland|princess|magic/, detail: 'The imaginative theme gives make-believe stories a natural starting point' },
    { pattern: /space|rocket|astronaut/, detail: 'The space theme connects creative play with curiosity about the wider world' }
  ];

  const buildFinderReason = ({ intent, budget, price }) => {
    return finderCopy('finderResultReason', 'Shown from products currently available in our store. Check the product page for age, materials and compatibility details.');
  };

  document.querySelectorAll('[data-merla-finder-form]').forEach((form) => {
    const prompt = form.querySelector('[data-finder-prompt]');
    const need = form.querySelector('[data-finder-need]');
    const budget = form.querySelector('[data-finder-budget]');
    const budgetMin = form.querySelector('[data-finder-budget-min]');
    const budgetControl = form.querySelector('[data-finder-budget-control]');
    const budgetChoices = form.querySelectorAll('[data-finder-budget-choice]');
    const budgetOutput = form.querySelector('[data-finder-budget-output]');
    const status = form.querySelector('[data-finder-status]');
    const submit = form.querySelector('[data-finder-submit]');

    const refreshBudgetOutput = (changed) => {
      if (!budgetOutput || !budget || !budgetMin) return;
      let minValue = Number(budgetMin.value || 0);
      let maxValue = Number(budget.value || budget.max || 150);
      if (changed === budgetMin && minValue > maxValue) {
        maxValue = minValue;
        budget.value = String(maxValue);
      }
      if (changed === budget && maxValue < minValue) {
        minValue = maxValue;
        budgetMin.value = String(minValue);
      }
      const ceiling = Number(budget.max || 150);
      budgetOutput.textContent = minValue === 0 && maxValue === ceiling
        ? form.dataset.finderAnyBudget || 'Any budget'
        : minValue === 0
          ? finderTemplate('finderUpTo', maxValue, `Up to C$${maxValue}`)
          : maxValue === ceiling
            ? finderTemplate('finderFrom', minValue, `From C$${minValue}`)
            : `C$${minValue}–C$${maxValue}`;
      budgetControl?.style.setProperty('--budget-min', `${Math.round((minValue / ceiling) * 100)}%`);
      budgetControl?.style.setProperty('--budget-max', `${Math.round((maxValue / ceiling) * 100)}%`);
      budgetChoices.forEach((choice) => {
        const selected = Number(choice.dataset.budgetMin) === minValue && Number(choice.dataset.budgetMax) === maxValue;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
    };
    budget?.addEventListener('input', () => refreshBudgetOutput(budget));
    budget?.addEventListener('change', () => refreshBudgetOutput(budget));
    budgetMin?.addEventListener('input', () => refreshBudgetOutput(budgetMin));
    budgetMin?.addEventListener('change', () => refreshBudgetOutput(budgetMin));
    budgetChoices.forEach((choice) => choice.addEventListener('click', () => {
      if (!budget || !budgetMin) return;
      budgetMin.value = choice.dataset.budgetMin || '0';
      budget.value = choice.dataset.budgetMax || budget.max || '150';
      refreshBudgetOutput();
    }));
    refreshBudgetOutput();

    form.querySelectorAll('[data-finder-example]').forEach((example) => {
      example.addEventListener('click', () => {
        prompt.value = example.dataset.finderExample || '';
        prompt.focus();
      });
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const promptValue = prompt?.value.trim() || '';
      if (promptValue.length < 3 && !need?.value) {
        status.textContent = form.dataset.finderStatusBegin || 'Add a few words or choose an everyday need to begin.';
        prompt?.focus();
        return;
      }

      if (!finderPromptIsInScope(promptValue, need?.value)) {
        status.textContent = form.dataset.finderStatusScope || 'Merla Finder can help with products, sizing, gifts, baby stages and shopping needs.';
        prompt?.setAttribute('aria-invalid', 'true');
        prompt?.focus();
        return;
      }

      prompt?.removeAttribute('aria-invalid');

      const selectedIntent = inferFinderIntent(promptValue, need?.value);
      const detectedBudget = promptValue.match(/(?:under|less than|budget|below|\$)\s*(?:c\$|cad|\$)?\s*(25|50|100|150)\b/i)?.[1];
      if (budget && Number(budget.value) >= Number(budget.max) && detectedBudget) {
        budget.value = detectedBudget;
        refreshBudgetOutput();
      }
      form.querySelector('[data-finder-search-term]').value = finderSearchTerm(promptValue, selectedIntent);
      form.querySelector('[data-finder-intent]').value = selectedIntent;
      form.querySelector('[data-finder-request-id]').value = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.querySelector('span')?.replaceChildren(form.dataset.finderStatusFinding || 'Finding their edit…');
      status.textContent = form.dataset.finderStatusMatching || 'Matching your words with the Merla Baby catalogue…';
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  document.querySelectorAll('[data-finder-results-page]').forEach((page) => {
    const params = new URLSearchParams(window.location.search);
    const prompt = params.get('finder_prompt')?.trim() || '';
    const intent = params.get('finder_intent') || inferFinderIntent(prompt, params.get('finder_need'));
    const requestedAge = params.get('finder_age') || '';
    const age = requestedAge === 'preschool' ? 'kids' : requestedAge;
    const requestedBudget = Number(params.get('finder_budget') || 0);
    const requestedBudgetMin = Number(params.get('finder_min_budget') || 0);
    const budget = requestedBudget >= 150 ? 0 : requestedBudget;
    const intentConfig = finderIntents[intent] || finderIntents.play;
    const ageLabels = Object.fromEntries(Array.from(document.querySelectorAll('[data-finder-age] option[value]')).map((option) => [option.value, option.textContent.trim()]));
    const summary = page.querySelector('[data-finder-summary]');
    const chips = page.querySelector('[data-finder-chips]');
    const cards = Array.from(page.querySelectorAll('[data-finder-product]'));
    let visibleCount = 0;

    if (summary) summary.textContent = prompt ? `“${prompt}”` : `A useful starting point for ${finderIntentLabel(intent).toLowerCase()}.`;
    [ageLabels[age], finderIntentLabel(intent), requestedBudgetMin ? finderTemplate('finderFrom', requestedBudgetMin, `From C$${requestedBudgetMin}`) : '', budget ? finderTemplate('finderUpTo', budget, `Up to C$${budget}`) : (requestedBudgetMin ? '' : finderCopy('finderAnyBudget', 'Any budget'))].filter(Boolean).forEach((label) => {
      const chip = document.createElement('span');
      chip.textContent = label;
      chips?.appendChild(chip);
    });

    cards.forEach((card) => {
      const product = card.querySelector('[data-product-card]');
      const price = Number(product?.dataset.productPrice || 0) / 100;
      const available = product?.dataset.productAvailable !== 'false';
      const visible = available && (!budget || price <= budget) && (!requestedBudgetMin || price >= requestedBudgetMin);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
      const reason = card.querySelector('[data-finder-reason]');
      if (reason) reason.textContent = buildFinderReason({
        product,
        intent,
        age,
        budget,
        price
      });
    });

    const count = page.querySelector('[data-finder-count]');
    if (count) count.textContent = visibleCount === 1 ? finderCopy('finderResultsCountOne', '1 match') : finderTemplate('finderResultsCount', visibleCount, `${visibleCount} matches`);
    const heading = page.querySelector('[data-finder-heading]');
    if (heading) heading.textContent = finderIntentLabel(intent);
    const empty = page.querySelector('[data-finder-empty]');
    if (empty) empty.hidden = visibleCount > 0;

    page.querySelectorAll('[data-merla-finder-form]').forEach((form) => {
      const promptInput = form.querySelector('[data-finder-prompt]');
      const ageInput = form.querySelector('[data-finder-age]');
      const needInput = form.querySelector('[data-finder-need]');
      const budgetInput = form.querySelector('[data-finder-budget]');
      const budgetMinInput = form.querySelector('[data-finder-budget-min]');
      if (promptInput) promptInput.value = prompt;
      if (ageInput) ageInput.value = age;
      if (needInput) needInput.value = intent;
      if (budgetMinInput && requestedBudgetMin) budgetMinInput.value = String(requestedBudgetMin);
      if (budgetInput) {
        budgetInput.value = String(requestedBudget || budgetInput.max || 150);
        budgetInput.dispatchEvent(new Event('input'));
      }
    });
  });

  document.querySelectorAll('[data-collection-section], [data-search-section]').forEach((section) => {
    const drawer = section.querySelector('[data-filter-drawer]');
    const open = section.querySelector('[data-filter-open]');
    const closeButtons = section.querySelectorAll('[data-filter-close]');
    const compactFilters = window.matchMedia('(max-width: 990px)');
    let filtersAreOpen = false;
    const getFilterFocusable = () => Array.from(drawer?.querySelectorAll('button:not([disabled]), input:not([disabled]), summary, a[href], select:not([disabled])') || [])
      .filter((item) => !item.hidden && item.offsetParent !== null);
    const setFiltersOpen = (isOpen, restoreFocus = true) => {
      filtersAreOpen = isOpen;
      drawer?.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('filters-open', isOpen);
      open?.setAttribute('aria-expanded', String(isOpen));
      if (drawer && compactFilters.matches) {
        drawer.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) {
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
        } else {
          drawer.removeAttribute('role');
          drawer.removeAttribute('aria-modal');
        }
      }
      if (isOpen) {
        window.setTimeout(() => drawer?.querySelector('[data-filter-close]')?.focus(), 50);
      } else if (restoreFocus) {
        open?.focus();
      }
    };
    open?.addEventListener('click', () => setFiltersOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setFiltersOpen(false)));
    if (drawer && compactFilters.matches) drawer.setAttribute('aria-hidden', 'true');
    compactFilters.addEventListener('change', (event) => {
      if (!event.matches) {
        setFiltersOpen(false, false);
        drawer?.removeAttribute('aria-hidden');
        drawer?.removeAttribute('role');
        drawer?.removeAttribute('aria-modal');
      } else if (drawer) {
        drawer.setAttribute('aria-hidden', String(!filtersAreOpen));
      }
    });
    section.addEventListener('keydown', (event) => {
      if (!filtersAreOpen || !compactFilters.matches) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setFiltersOpen(false);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFilterFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const grid = section.querySelector('[data-collection-grid]');
    const viewButtons = Array.from(section.querySelectorAll('[data-grid-columns]'));
    let savedColumns;
    try { savedColumns = window.localStorage.getItem('merla:grid-columns'); } catch (_error) { savedColumns = null; }

    const setColumns = (columns) => {
      if (!grid) return;
      grid.classList.toggle('collection-product-grid--two', columns === '2');
      viewButtons.forEach((button) => {
        const active = button.dataset.gridColumns === columns;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      try { window.localStorage.setItem('merla:grid-columns', columns); } catch (_error) { /* storage is optional */ }
    };

    if (savedColumns === '2' || savedColumns === '4') setColumns(savedColumns);
    viewButtons.forEach((button) => button.addEventListener('click', () => setColumns(button.dataset.gridColumns)));

  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (!section.dataset.url || section.querySelector('.product-card')) return;
    try {
      const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-product-recommendations]');
      if (replacement?.querySelector('.product-card')) section.replaceWith(replacement);
      else section.remove();
    } catch (_error) {
      /* Recommendations are optional and should never block product purchase. */
    }
  });

  document.querySelectorAll('[data-product-guide]').forEach((guide) => {
    const rows = Array.from(guide.querySelectorAll('[data-guide-row]'));
    const status = guide.querySelector('[data-guide-status]');
    const parseRange = (text) => {
      const values = String(text || '').match(/\d+(?:\.\d+)?/g)?.map(Number) || [];
      if (!values.length) return null;
      return { min: values[0], max: values[1] ?? (String(text).includes('+') ? Infinity : values[0]) };
    };
    const matchesRange = (value, text) => {
      if (!Number.isFinite(value)) return true;
      const range = parseRange(text);
      return range ? value >= range.min && value <= range.max : true;
    };

    const submit = guide.querySelector('[data-guide-submit]');
    submit?.addEventListener('click', () => {
      const ageInput = guide.querySelector('[data-guide-age]');
      const heightInput = guide.querySelector('[data-guide-height]');
      const weightInput = guide.querySelector('[data-guide-weight]');
      const age = ageInput?.value === '' ? NaN : Number(ageInput?.value);
      const height = heightInput?.value === '' || !heightInput ? NaN : Number(heightInput.value);
      const weight = weightInput?.value === '' || !weightInput ? NaN : Number(weightInput.value);

      if (![age, height, weight].some(Number.isFinite)) {
        status.textContent = 'Enter at least one measurement to see a recommendation.';
        return;
      }

      let matches = rows.filter((row) => matchesRange(age, row.dataset.age) && matchesRange(height, row.dataset.height) && matchesRange(weight, row.dataset.weight));
      if (!matches.length && Number.isFinite(age)) matches = rows.filter((row) => matchesRange(age, row.dataset.age));
      rows.forEach((row) => row.classList.toggle('is-recommended', matches.includes(row)));
      const labels = matches.map((row) => row.dataset.size).filter(Boolean).join(' or ');
      status.textContent = matches.length ? `Suggested starting point: ${labels}.` : 'No exact match found. Check the brand notes or contact our parent support team.';
      matches[0]?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    });

    const compatibilitySearch = guide.querySelector('[data-compatibility-search]');
    compatibilitySearch?.addEventListener('input', () => {
      const query = compatibilitySearch.value.trim().toLowerCase();
      let visible = 0;
      rows.forEach((row) => {
        const match = !query || row.textContent.toLowerCase().includes(query);
        row.hidden = !match;
        if (match) visible += 1;
      });
      status.textContent = query ? `${visible} compatible entr${visible === 1 ? 'y' : 'ies'} found.` : 'Always confirm the exact model generation before purchase.';
    });
  });

  document.querySelectorAll('[data-recover-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const loginPanel = document.querySelector('[data-login-panel]');
      const recoverPanel = document.querySelector('[data-recover-panel]');
      if (!loginPanel || !recoverPanel) return;
      const showRecover = recoverPanel.hidden;
      recoverPanel.hidden = !showRecover;
      loginPanel.hidden = showRecover;
      (showRecover ? recoverPanel : loginPanel).querySelector('input')?.focus();
    });
  });

  document.querySelectorAll('[data-address-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.dataset.addressToggle);
      if (!panel) return;
      panel.hidden = !panel.hidden;
      if (!panel.hidden) panel.querySelector('input')?.focus();
    });
  });

  document.querySelectorAll('[data-address-delete]').forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!window.confirm('Delete this address?')) event.preventDefault();
    });
  });

  document.querySelectorAll('[data-address-country-select]').forEach((countrySelect) => {
    const provinceSelect = countrySelect.parentElement?.querySelector('[data-address-province-wrap] select')
      || countrySelect.closest('form')?.querySelector('[data-address-province-wrap] select');
    const provinceWrap = provinceSelect?.closest('[data-address-province-wrap]');
    const updateProvinces = () => {
      if (!provinceSelect || !provinceWrap) return;
      let provinces = [];
      try { provinces = JSON.parse(countrySelect.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_error) { provinces = []; }
      provinceSelect.innerHTML = '';
      provinces.forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        if (value === provinceSelect.dataset.default) option.selected = true;
        provinceSelect.append(option);
      });
      provinceWrap.hidden = provinces.length === 0;
    };
    if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;
    countrySelect.addEventListener('change', updateProvinces);
    updateProvinces();
  });

  document.querySelectorAll('[data-gift-recipient]').forEach((recipient) => {
    const toggle = recipient.querySelector('[data-gift-recipient-toggle]');
    const fields = recipient.querySelector('[data-gift-recipient-fields]');
    if (!toggle || !fields) return;
    toggle.addEventListener('change', () => {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, textarea').forEach((field) => { field.disabled = !toggle.checked; });
      const offset = fields.querySelector('[data-gift-recipient-offset]');
      if (offset && toggle.checked) offset.value = new Date().getTimezoneOffset();
      if (toggle.checked) fields.querySelector('input')?.focus();
    });
  });

  document.querySelectorAll('[data-faq-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.faqFilter;
      const faqPage = button.closest('.faq-page') || document;
      const filterButtons = faqPage.querySelectorAll('[data-faq-filter]');
      const questions = faqPage.querySelectorAll('[data-faq-item]');
      let visibleCount = 0;
      filterButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      questions.forEach((item) => {
        const visible = filter === 'all' || item.dataset.faqItem === filter;
        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) visibleCount += 1;
      });
      const status = faqPage.querySelector('[data-faq-status]');
      if (status) status.textContent = `${visibleCount} question${visibleCount === 1 ? '' : 's'} shown.`;
    });
  });

  document.querySelectorAll('[data-brand-search]').forEach((input) => {
    const brandPage = input.closest('.brand-page') || document;
    const clearButton = brandPage.querySelector('[data-brand-clear]');
    const updateBrandDirectory = () => {
      const query = input.value.trim().toLowerCase();
      let totalVisible = 0;
      brandPage.querySelectorAll('[data-brand-group]').forEach((group) => {
        let groupVisible = 0;
        group.querySelectorAll('[data-brand-item]').forEach((item) => {
          const visible = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !visible;
          if (visible) groupVisible += 1;
        });
        group.hidden = groupVisible === 0;
        totalVisible += groupVisible;
      });
      const noResults = brandPage.querySelector('[data-brand-no-results]');
      if (noResults) noResults.hidden = totalVisible > 0;
      if (clearButton) clearButton.hidden = query.length === 0;
    };
    input.addEventListener('input', updateBrandDirectory);
    input.addEventListener('search', updateBrandDirectory);
    input.addEventListener('change', updateBrandDirectory);
    if (clearButton) {
      clearButton.addEventListener('click', () => {
        input.value = '';
        updateBrandDirectory();
        input.focus();
      });
    }
    updateBrandDirectory();
  });

  const passwordDialog = document.querySelector('[data-password-dialog]');
  const passwordDialogOpener = document.querySelector('[data-password-dialog-open]');
  const setPasswordDialogOpen = (open) => {
    if (!passwordDialog) return;
    passwordDialog.hidden = !open;
    document.body.classList.toggle('password-dialog-open', open);
    if (open) window.setTimeout(() => passwordDialog.querySelector('.password-dialog__panel')?.focus(), 30);
    else passwordDialogOpener?.focus();
  };
  passwordDialogOpener?.addEventListener('click', () => setPasswordDialogOpen(true));
  passwordDialog?.querySelectorAll('[data-password-dialog-close]').forEach((button) => button.addEventListener('click', () => setPasswordDialogOpen(false)));
  if (passwordDialog) {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !passwordDialog.hidden) setPasswordDialogOpen(false);
      else if (!passwordDialog.hidden) trapFocus(event, passwordDialog.querySelector('.password-dialog__panel'));
    });
  }

  document.querySelectorAll('[data-gift-card-copy]').forEach((button) => {
    button.addEventListener('click', async () => {
      const target = document.getElementById(button.dataset.copyTarget);
      if (!target) return;
      try {
        await navigator.clipboard.writeText(target.textContent.replace(/\s/g, ''));
        const original = button.textContent;
        button.textContent = 'Copied';
        const liveRegion = document.getElementById('CartLiveRegion');
        if (liveRegion) liveRegion.textContent = cartCopy('cartGiftCardCopied', 'Gift card code copied.');
        window.setTimeout(() => { button.textContent = original; }, 1800);
      } catch (_error) {
        const range = document.createRange();
        range.selectNodeContents(target);
        window.getSelection()?.removeAllRanges();
        window.getSelection()?.addRange(range);
      }
    });
  });

  document.querySelectorAll('[data-gift-card-qr]').forEach((container) => {
    if (window.QRCode) new window.QRCode(container, { text: container.dataset.giftCardQr, width: 80, height: 80 });
  });

  const privacyBanner = document.querySelector('[data-privacy-banner]');
  if (privacyBanner) {
    const privacyStorageKey = 'merla-baby:privacy-consent';
    const privacyApi = window.Shopify?.customerPrivacy;
    const summary = privacyBanner.querySelector('.privacy-banner__summary');
    const preferencesPanel = privacyBanner.querySelector('[data-privacy-preferences]');
    const showBanner = () => {
      let shouldShow = true;
      try {
        shouldShow = !window.localStorage.getItem(privacyStorageKey);
        if (privacyApi?.shouldShowBanner) shouldShow = privacyApi.shouldShowBanner();
      } catch (_error) { /* Show the choice when storage is unavailable. */ }
      privacyBanner.hidden = !shouldShow;
      document.body.classList.toggle('privacy-open', shouldShow);
    };
    const setConsent = (consent) => {
      const finish = () => {
        try { window.localStorage.setItem(privacyStorageKey, JSON.stringify(consent)); } catch (_error) { /* Storage can be disabled. */ }
        privacyBanner.hidden = true;
        document.body.classList.remove('privacy-open');
      };
      try {
        if (privacyApi?.setTrackingConsent) {
          privacyApi.setTrackingConsent({
            analytics: consent.analytics,
            marketing: consent.marketing,
            preferences: consent.preferences,
            sale_of_data: 'disabled'
          }, finish);
        } else finish();
      } catch (_error) { finish(); }
    };
    const rejectOptional = () => setConsent({ analytics: false, marketing: false, preferences: false });
    privacyBanner.querySelectorAll('[data-privacy-accept]').forEach((button) => button.addEventListener('click', () => setConsent({ analytics: true, marketing: true, preferences: true })));
    privacyBanner.querySelectorAll('[data-privacy-reject]').forEach((button) => button.addEventListener('click', rejectOptional));
    privacyBanner.querySelector('[data-privacy-manage]')?.addEventListener('click', () => {
      summary.hidden = true;
      preferencesPanel.hidden = false;
      preferencesPanel.querySelector('input:not([disabled])')?.focus();
    });
    privacyBanner.querySelector('button[data-privacy-summary]')?.addEventListener('click', () => {
      preferencesPanel.hidden = true;
      summary.hidden = false;
      privacyBanner.querySelector('[data-privacy-manage]')?.focus();
    });
    privacyBanner.querySelector('[data-privacy-save]')?.addEventListener('click', () => setConsent({
      preferences: Boolean(privacyBanner.querySelector('[data-consent-preferences]')?.checked),
      analytics: Boolean(privacyBanner.querySelector('[data-consent-analytics]')?.checked),
      marketing: Boolean(privacyBanner.querySelector('[data-consent-marketing]')?.checked)
    }));
    showBanner();
  }

  const wishlistKey = 'merla-baby:wishlist';
  const wishlistCopySource = document.querySelector('[data-wishlist-copy]');
  const wishlistCopy = (key, fallback = '') => wishlistCopySource?.dataset[key] || fallback;
  const wishlistTemplate = (key, value, fallback) => wishlistCopy(key, fallback).replace(/__title__|__count__/g, String(value));
  const readWishlist = () => {
    try {
      const saved = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(saved) ? saved.filter((item) => item?.handle) : [];
    } catch (_error) {
      return [];
    }
  };
  const writeWishlist = (items) => {
    try { window.localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (_error) { /* Storage can be disabled. */ }
  };
  const wishlistItemFromButton = (button) => ({
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    variantId: button.dataset.productVariantId || ''
  });
  const announceWishlist = (message) => {
    const region = document.querySelector('[data-wishlist-status]') || document.getElementById('CartLiveRegion');
    if (!region) return;
    region.textContent = '';
    window.requestAnimationFrame(() => { region.textContent = message; });
  };
  const syncWishlistButtons = (items) => {
    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      if (button.matches('.product-wishlist')) {
        button.lastElementChild.textContent = active
          ? wishlistCopy('wishlistSavedText', 'Saved')
          : wishlistCopy('wishlistSaveText', 'Save');
      }
      button.setAttribute('aria-label', active
        ? wishlistTemplate('wishlistRemoveLabel', button.dataset.productTitle, `Remove ${button.dataset.productTitle} from wishlist`)
        : wishlistTemplate('wishlistSaveLabel', button.dataset.productTitle, `Save ${button.dataset.productTitle} to wishlist`));
    });
  };
  const renderWishlist = () => {
    const grids = Array.from(document.querySelectorAll('[data-wishlist-grid], [data-wishlist-drawer-items]'));
    const items = readWishlist();
    syncWishlistButtons(items);
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = items.length;
      if (count.hasAttribute('data-wishlist-badge')) count.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
      link.setAttribute('aria-label', wishlistTemplate(
        items.length === 1 ? 'wishlistLinkOne' : 'wishlistLinkOther',
        items.length,
        `Wishlist, ${items.length} saved item${items.length === 1 ? '' : 's'}`
      ));
    });
    document.querySelectorAll('[data-wishlist-count-label]').forEach((label) => {
      label.textContent = wishlistCopy(
        items.length === 1 ? 'wishlistCountOne' : 'wishlistCountOther',
        items.length === 1 ? 'saved item' : 'saved items'
      );
    });
    document.querySelectorAll('[data-wishlist-action]').forEach((button) => {
      button.disabled = items.length === 0;
      button.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-wishlist-empty], [data-wishlist-drawer-empty]').forEach((empty) => {
      empty.hidden = items.length > 0;
    });
    if (!grids.length) return;
    grids.forEach((grid) => { grid.innerHTML = ''; });

    items.forEach((item) => {
      grids.forEach((grid) => {
        const drawerItem = grid.hasAttribute('data-wishlist-drawer-items');
        const article = document.createElement('article');
        article.className = `wishlist-card${drawerItem ? ' wishlist-card--drawer' : ''}`;
        article.dataset.productHandle = item.handle;
        const media = document.createElement('a');
        media.className = 'wishlist-card__media';
        media.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = secureImageUrl(item.image);
          image.alt = item.title;
          image.loading = 'lazy';
          media.append(image);
        }
        const copy = document.createElement('div');
        copy.className = 'wishlist-card__copy';
        const title = document.createElement('h2');
        const titleLink = document.createElement('a');
        titleLink.href = item.url;
        titleLink.textContent = item.title;
        title.append(titleLink);
        const price = document.createElement('p');
        price.textContent = item.price;
        const actions = document.createElement('div');
        actions.className = 'wishlist-card__actions';
        const primary = document.createElement(item.variantId ? 'button' : 'a');
        primary.className = 'button button--solid';
        primary.textContent = item.variantId
          ? wishlistCopy('wishlistAdd', 'Add to bag')
          : wishlistCopy('wishlistChooseOptions', 'Choose options');
        if (item.variantId) {
          primary.type = 'button';
          primary.dataset.wishlistAdd = '';
          primary.dataset.variantId = item.variantId;
        } else {
          primary.href = item.url;
        }
        const remove = document.createElement('button');
        remove.className = 'text-link';
        remove.type = 'button';
        remove.dataset.wishlistRemove = item.handle;
        remove.textContent = wishlistCopy('wishlistRemove', 'Remove');
        actions.append(primary, remove);
        copy.append(title, price, actions);
        article.append(media, copy);
        grid.append(article);
      });
    });
  };

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const items = readWishlist();
      const index = items.findIndex((item) => item.handle === toggle.dataset.productHandle);
      if (index >= 0) items.splice(index, 1);
      else items.unshift(wishlistItemFromButton(toggle));
      writeWishlist(items);
      renderWishlist();
      announceWishlist(index >= 0
        ? wishlistTemplate('wishlistRemovedStatus', toggle.dataset.productTitle, `${toggle.dataset.productTitle} removed from your wishlist.`)
        : wishlistTemplate('wishlistSavedStatus', toggle.dataset.productTitle, `${toggle.dataset.productTitle} saved to your wishlist.`));
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const grid = remove.closest('[data-wishlist-grid], [data-wishlist-drawer-items]');
      const cards = Array.from(grid?.querySelectorAll('.wishlist-card') || []);
      const cardIndex = cards.indexOf(remove.closest('.wishlist-card'));
      const nextHandle = cards[cardIndex + 1]?.dataset.productHandle || cards[cardIndex - 1]?.dataset.productHandle || '';
      writeWishlist(readWishlist().filter((item) => item.handle !== remove.dataset.wishlistRemove));
      renderWishlist();
      const nextButton = Array.from(grid?.querySelectorAll('[data-wishlist-remove]') || []).find((button) => button.dataset.wishlistRemove === nextHandle);
      (nextButton || document.querySelector('[data-wishlist-drawer-empty] .cart-drawer__continue, [data-wishlist-empty] .button'))?.focus();
      announceWishlist(wishlistCopy('wishlistRemovedItemStatus', 'Item removed from your wishlist.'));
      return;
    }

    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      const root = document.body.dataset.rootUrl || '/';
      const original = add.textContent;
      add.disabled = true;
      add.textContent = wishlistCopy('wishlistAdding', 'Adding…');
      try {
        const formData = new FormData();
        formData.append('id', add.dataset.variantId);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const data = await response.json();
        if (!response.ok) throw new Error(publicCartError(data.description, 'cartAddError', 'This item could not be added.'));
        replaceCartDrawer(data.sections?.['cart-drawer']);
        const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((result) => result.json());
        updateCartCount(cart.item_count);
        await refreshCartPage();
        setCartOpen(true);
        announceWishlist(wishlistCopy('wishlistAddedStatus', 'Item added to your bag.'));
      } catch (error) {
        announceWishlist(error.message);
      } finally {
        add.disabled = false;
        add.textContent = original;
      }
      return;
    }

    if (event.target.closest('[data-clear-wishlist]')) {
      if (readWishlist().length && window.confirm(wishlistCopy('wishlistClearConfirm', 'Clear your entire wishlist?'))) {
        writeWishlist([]);
        renderWishlist();
        document.querySelector('[data-wishlist-empty] .button')?.focus();
        announceWishlist(wishlistCopy('wishlistClearedStatus', 'Wishlist cleared.'));
      }
      return;
    }

    const share = event.target.closest('[data-share-wishlist]');
    if (share) {
      const items = readWishlist();
      if (!items.length) return;
      const text = items.map((item) => `${item.title}: ${new URL(item.url, window.location.origin).href}`).join('\n');
      try {
        if (navigator.share) await navigator.share({ title: wishlistCopy('wishlistShareTitle', 'My Merla Baby wishlist'), text });
        else {
          await navigator.clipboard.writeText(text);
          const original = share.textContent;
          share.textContent = wishlistCopy('wishlistCopied', 'Copied');
          announceWishlist(wishlistCopy('wishlistSharedStatus', 'Wishlist links copied.'));
          window.setTimeout(() => { share.textContent = original; }, 1800);
        }
      } catch (_error) { /* The share sheet may be cancelled. */ }
    }
  });

  const quickFinder = document.querySelector('[data-quick-finder]');
  if (quickFinder) {
    const opener = quickFinder.querySelector('[data-quick-finder-open]');
    const dialog = quickFinder.querySelector('[data-quick-finder-dialog]');
    const panel = quickFinder.querySelector('[data-quick-finder-panel]');
    const closeButtons = quickFinder.querySelectorAll('[data-quick-finder-close]');
    const onboarding = quickFinder.querySelector('[data-guide-onboarding]');
    const onboardingKey = 'merla-baby:guide-onboarding-v1';
    const motion = window.MerlaMotion?.gsap;
    const reducedMotion = window.MerlaMotion?.prefersReducedMotion;
    let closeTimer;

    const closeQuickFinder = () => {
      if (!dialog || dialog.hidden) return;
      window.clearTimeout(closeTimer);
      const finish = () => {
        dialog.hidden = true;
        document.body.classList.remove('finder-open');
        opener?.setAttribute('aria-expanded', 'false');
        opener?.focus();
      };
      if (motion && !reducedMotion) {
        motion.to(panel, { autoAlpha: 0, y: 18, duration: 0.18, ease: 'power1.in', onComplete: finish });
      } else {
        finish();
      }
    };

    const openQuickFinder = () => {
      if (!dialog || !opener) return;
      dismissOnboarding();
      window.clearTimeout(closeTimer);
      document.body.classList.add('finder-open');
      dialog.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      if (motion && !reducedMotion) {
        motion.fromTo(panel, { autoAlpha: 0, y: 22, scale: 0.985 }, { autoAlpha: 1, y: 0, scale: 1, duration: 0.28, ease: 'power2.out', clearProps: 'transform' });
      }
      window.setTimeout(() => panel?.querySelector('[data-finder-prompt]')?.focus(), 30);
    };

    const rememberOnboarding = () => {
      try { window.localStorage.setItem(onboardingKey, 'seen'); } catch (_error) { /* Storage can be disabled. */ }
    };

    const dismissOnboarding = () => {
      if (!onboarding || onboarding.hidden) return;
      onboarding.hidden = true;
      opener?.classList.remove('is-onboarding');
      rememberOnboarding();
    };

    const showOnboarding = () => {
      if (!onboarding || !opener || !document.body.classList.contains('template-index')) return;
      let hasSeen = false;
      try { hasSeen = window.localStorage.getItem(onboardingKey) === 'seen'; } catch (_error) { /* Storage can be disabled. */ }
      if (hasSeen) return;
      const privacyPrompt = document.querySelector('[data-privacy-banner]:not([hidden])');
      if (privacyPrompt) {
        window.setTimeout(showOnboarding, 600);
        return;
      }
      onboarding.hidden = false;
      opener.classList.add('is-onboarding');
    };

    opener?.addEventListener('click', openQuickFinder);
    closeButtons.forEach((button) => button.addEventListener('click', closeQuickFinder));
    onboarding?.querySelectorAll('[data-guide-onboarding-dismiss]').forEach((button) => button.addEventListener('click', dismissOnboarding));
    onboarding?.querySelector('[data-guide-onboarding-open]')?.addEventListener('click', openQuickFinder);
    window.setTimeout(() => showOnboarding(), 900);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeQuickFinder();
      else if (dialog && !dialog.hidden) trapFocus(event, panel);
    });
  }

  document.querySelectorAll('[data-copy-contact]').forEach((button) => {
    button.addEventListener('click', async () => {
      const value = button.dataset.copyContact || '';
      const status = button.querySelector('[data-copy-contact-status]');
      if (!value) return;

      const copyWithSelection = () => {
        const field = document.createElement('textarea');
        field.value = value;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand('copy');
        field.remove();
        return copied;
      };

      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
          copied = true;
        } else {
          copied = copyWithSelection();
        }
      } catch (_error) {
        copied = copyWithSelection();
      }

      if (status) status.textContent = copied ? 'Copied' : 'Select ID';
      if (copied) {
        window.setTimeout(() => {
          if (status) status.textContent = 'Copy';
        }, 1800);
      }
    });
  });

  document.querySelectorAll('[data-contact-topic]').forEach((select) => {
    const trigger = select.querySelector('[data-contact-topic-button]');
    const options = select.querySelector('[data-contact-topic-options]');
    const value = select.querySelector('[data-contact-topic-value]');
    const text = select.querySelector('[data-contact-topic-text]');
    const choices = Array.from(select.querySelectorAll('[data-contact-topic-option]'));
    if (!trigger || !options || !value || !text || !choices.length) return;

    const close = (restoreFocus = false) => {
      options.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    };

    const open = () => {
      options.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const choose = (choice) => {
      value.value = choice.dataset.contactTopicOption || choice.textContent.trim();
      text.textContent = choice.textContent.trim();
      choices.forEach((item) => item.setAttribute('aria-selected', String(item === choice)));
      close(true);
    };

    trigger.addEventListener('click', () => options.hidden ? open() : close());
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open();
        const selected = choices.find((item) => item.getAttribute('aria-selected') === 'true') || choices[0];
        selected.focus();
      }
      if (event.key === 'Escape') close();
    });

    choices.forEach((choice, index) => {
      choice.addEventListener('click', () => choose(choice));
      choice.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(choice);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          choices[(index + (event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length].focus();
        } else if (event.key === 'Tab') {
          close();
        }
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (!select.contains(event.target)) close();
    });
  });

  document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-testimonial-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-testimonial-slide]'));
    const dots = carousel.querySelector('[data-testimonial-dots]');
    const previous = carousel.querySelector('[data-testimonial-previous]');
    const next = carousel.querySelector('[data-testimonial-next]');
    if (!track || slides.length < 2) return;

    let current = 0;
    const visibleSlides = () => window.matchMedia('(max-width: 760px)').matches ? 1 : 2;
    const maxIndex = () => Math.max(0, slides.length - visibleSlides());
    const rebuildDots = () => {
      if (!dots) return;
      const pages = maxIndex() + 1;
      dots.replaceChildren();
      for (let index = 0; index < pages; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.addEventListener('click', () => { current = index; render(); });
        dots.append(dot);
      }
    };
    const render = () => {
      current = Math.min(Math.max(current, 0), maxIndex());
      track.style.transform = `translateX(calc(${current} * -100% / ${visibleSlides()}))`;
      dots?.querySelectorAll('button').forEach((dot, index) => {
        const active = index === current;
        dot.setAttribute('aria-current', String(active));
        dot.setAttribute('aria-label', `Show review ${index + 1}`);
      });
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = current === maxIndex();
      carousel.querySelector('.testimonials__controls')?.toggleAttribute('hidden', maxIndex() === 0);
    };
    previous?.addEventListener('click', () => { current -= 1; render(); });
    next?.addEventListener('click', () => { current += 1; render(); });
    window.addEventListener('resize', () => { rebuildDots(); render(); }, { passive: true });
    rebuildDots();
    render();
  });

  const findBonLauncher = () => {
    const selectors = [
      '[data-bon-loyalty-launcher]',
      '[data-bon-launcher]',
      '[data-bon-widget-launcher]',
      '#bon-loyalty-widget-launcher',
      '.bon-loyalty-widget-launcher',
      '.bon-launcher'
    ];

    return selectors
      .map((selector) => document.querySelector(selector))
      .find((launcher) => launcher && launcher.offsetParent !== null);
  };

  document.querySelectorAll('[data-rewards-launcher]').forEach((launcher) => {
    launcher.addEventListener('click', (event) => {
      const bonLauncher = findBonLauncher();
      document.dispatchEvent(new CustomEvent('merla:rewards:open'));

      if (bonLauncher && bonLauncher !== launcher) {
        event.preventDefault();
        bonLauncher.click();
      }
    });
  });

  renderWishlist();

  const formStatus = document.querySelector('[data-form-status]');
  if (formStatus) window.setTimeout(() => formStatus.focus(), 50);
});
